// Runs `handler` once the window has stopped resizing for `delay` ms, and
// returns a teardown that removes the listener and drops a pending call.
//
// The default 150ms is what both callers measured against: the work behind it
// forces a synchronous layout, and iOS fires `resize` on every URL-bar
// show/hide while scrolling — which is exactly when a scroll-driven section is
// already doing its own measuring.
export default function debouncedResize(handler, delay = 150) {
  let timeout = null
  const onResize = () => {
    clearTimeout(timeout)
    timeout = setTimeout(handler, delay)
  }

  window.addEventListener('resize', onResize)

  return () => {
    window.removeEventListener('resize', onResize)
    clearTimeout(timeout)
  }
}
